import { Header, Lore, About, Roadmap, Team, Faq } from '../containers';
import { ChadsContent, Footer, MobileNavbar } from '../components';
import AboutPage from './About';

const Simps = () => {
    return(
    <div className="w-screen text-center select-none">
        <ChadsContent />
    </div>
    )};
  
  export default Simps;